// Libraries
var React = require('react');

// Components
var Icon = require('../../common/Icon/Icon.js');

// Styles
require('./CallToAction.scss');

// linkstyle of primary adds arrow


class CallToAction extends React.Component {
	render() {
		let link = null;
		let linkStyle = this.props.linkStyle ? this.props.linkStyle.toLowerCase() : "primary";
		const icon = !this.props.button ? <Icon name="chevronRightAltTwo" width={11} height={17} className="" /> : null;

		if ((linkStyle === 'disabled') ||
			(linkStyle === 'disabled-secondary')) {
			link = <span className={(this.props.center ? "center" : "")}>{this.props.caption}</span>;
		} else if (this.props.url === "") {
			link = <a className={(this.props.center ? "center" : "") + (this.props.url === "" ? " close" : "")} target={this.props.newWindow ? "_blank" : "_self"} rel={this.props.newWindow ? "noopener noreferrer" : undefined} tabIndex="0">
				{this.props.caption}{icon}
			</a>;
		} else {
			link = <a aria-label={this.props.ariaLabel} href={this.props.url} className={(this.props.center ? "center" : "") + (this.props.url === "" ? " close" : "")} target={this.props.newWindow ? "_blank" : "_self"} rel={this.props.newWindow ? "noopener noreferrer" : undefined}>
				{this.props.caption}{icon}
			</a>;
		}

		let buttonColor = "";
		if (this.props.button && linkStyle === "primary" && this.props.color && this.props.color !== "default") {
			buttonColor += "-" + this.props.color;
		}

		return (
			<div className={"CallToAction CallToAction--" + linkStyle + (this.props.shade === "light" ? " CallToAction--dark" : "") + (this.props.button ? " button" + buttonColor : "")}>
				{link}
			</div>
		)
	}
}

module.exports = CallToAction;




// WEBPACK FOOTER //
// ./src/common/CallToAction/CallToAction.js